<template>
  <v-container
    fluid>
    <v-row
      justify="center">
      <v-col
        cols="12"
        md="6">
        <v-card>
          <v-container
            fluid>
            <v-row>
              <v-col cols="12">
                <v-card-title class="headline font-weight-bold">{{ pupilFullName }}</v-card-title>
              </v-col>
              <div v-if="Dbasename !== 'Somerville'">
                <v-col cols="12">
                  <v-card-title class="subheading font-weight-bold pt-0">{{ pupilRoom.replace('Rm', 'Room ') + ' - ' + pupilForm.replace('Y', 'Year ') }}</v-card-title>
                </v-col>
              </div>
              <v-col
                cols="12"
                class="text-center pb-2">
                <v-avatar
                  tile
                  size="200">
                  <v-img :src="pupilPhoto"/>
                </v-avatar>
              </v-col>
              <v-col
                cols="12">
                <v-alert
                  :value="true"
                  color="#0C2340"
                  outlined
                >
                  If any of these details are incorrect, please contact the school to amend them.
                  <router-link
                    v-if="typeof menuConfig['School Contact'] !== 'undefined' || typeof menuConfig['Contacts'] !== 'undefined'"
                    to="/contact">Click here for contact details</router-link>
                </v-alert>
              </v-col>

              <v-col cols="12">
                <v-tabs
                  v-model="active"
                  show-arrows
                  grow>
                  <v-tabs-slider color="blue"/>
                  <v-tab href="#tab-1">My Child</v-tab>
                  <v-tab
                    href="#tab-2"
                    v-if="caregiverDetails.length !== 0">Contact</v-tab>
                  <v-tab
                    href="#tab-3"
                    v-if="medicalDetails.length !== 0 || doctorDetails.length !== 0">Medical</v-tab>
                  <v-tab
                    href="#tab-4"
                    v-if="permissions.length > 0">Permissions</v-tab>
                  <v-tab
                    href="#tab-5"
                    v-if="otherDetailsArr.length !== 0">Other Details</v-tab>
                  <v-tab
                    href="#tab-6"
                    v-if="attendance.length !== 0">Attendance For Today</v-tab>
                </v-tabs>

                <v-tabs-items
                  touchless
                  v-model="active">
                  <v-tab-item
                    value="tab-1"
                    transition="fade-transition"
                    reverse-transition="fade-transition">

                    <v-simple-table>
                      <template v-slot:default>
                        <tbody>
                          <tr
                            v-for="item in detailHeadingsForTable"
                            :key="item.detailName">
                            <template v-if="pupilDetails[item.detailName]!=''">
                              <td class="font-weight-bold">{{ item.heading }}</td>
                              <td class="text-right">{{ pupilDetails[item.detailName] }}</td>
                            </template>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-tab-item>

                  <v-tab-item
                    v-if="caregiverDetails.length > 0"
                    value="tab-2"
                    class="pl-2"
                    transition="fade-transition"
                    reverse-transition="fade-transition">
                    <v-card-actions>
                      <v-btn
                        v-if="showChildUpdateButton === false"
                        @click="openUpdate">Update Caregiver Details</v-btn>
                    </v-card-actions>
                    <v-dialog
                      v-model="dialogVisible"
                      max-width="600">
                      <v-card>
                        <v-card-title>Update Caregiver Details - {{ this.$store.state.parentName }}</v-card-title>
                        <v-card-text>
                          <v-text-field
                            v-model="editedCaregiver.email"
                            label="Email"/>
                          <v-text-field
                            v-model="editedCaregiver.address"
                            label="Address 1 (max 50 characters)"
                            maxlength="50"
                          />
                          <v-text-field
                            v-model="editedCaregiver.address2"
                            label="Address 2 (max 50 characters)"
                            maxlength="50"
                          />
                          <v-text-field
                            v-model="editedCaregiver.mobile"
                            label="Mobile"/>
                          <v-text-field
                            v-model="editedCaregiver.phone"
                            label="Phone"/>
                          <v-text-field
                            v-model="editedCaregiver.workphone"
                            label="Work Phone"/>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn @click="updateCaregiverDetails">Save</v-btn>
                          <v-btn @click="dialogVisible = false">Cancel</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-card
                      class="elevation-0 pb-1"
                      v-for="(caregiver, i) in caregiverDetails"
                      :key="i">
                      <v-card-title class="font-weight-bold pl-0 pb-1 subtitle-2">{{ caregiver.name }}</v-card-title>
                      <v-card-text
                        v-if="(caregiver.address !== '' || caregiver.address2 !== '' || caregiver.address3 !== '' || caregiver.address4 !== '') && (caregiver.address !== null || caregiver.address2 !== null || caregiver.address3 !== null || caregiver.address4 !== null)"
                        class="pa-0 font-weight-bold">
                        Address: <v-card-text class="font-weight-regular text-left pt-0 pb-0">{{ caregiver.address }} {{ caregiver.address2 }} {{ caregiver.address3 }} {{ caregiver.address4 }}</v-card-text>
                      </v-card-text>
                      <v-card-text
                        v-if="caregiver.email !== '' && caregiver.email !== null"
                        class="pa-0 font-weight-bold">
                        Email: <v-card-text class="font-weight-regular text-left pt-0 pb-0">{{ caregiver.email }}</v-card-text>
                      </v-card-text>
                      <v-card-text
                        v-if="caregiver.phone !== '' && caregiver.phone !== null"
                        class="pa-0 font-weight-bold">
                        Phone: <v-card-text class="font-weight-regular text-left pt-0 pb-0">{{ caregiver.phone }}</v-card-text>
                      </v-card-text>
                      <v-card-text
                        v-if="caregiver.mobile !== '' && caregiver.mobile !== null"
                        class="pa-0 font-weight-bold">
                        Mobile: <v-card-text class="font-weight-regular text-left pt-0 pb-0">{{ caregiver.mobile }}</v-card-text>
                      </v-card-text>
                      <v-card-text
                        v-if="caregiver.workphone !== '' && caregiver.workphone !== null"
                        class="pa-0 font-weight-bold">
                        Work Phone: <v-card-text class="font-weight-regular text-left pt-0 pb-0">{{ caregiver.workphone }}</v-card-text>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item
                    value="tab-3"
                    class="pl-2"
                    transition="fade-transition"
                    reverse-transition="fade-transition"
                  >
                    <span class="font-weight-bold">Doctor: </span>
                    <span v-if="doctorDetails.length === 0">Not recorded<br></span>
                    <span v-else>
                      <span
                        v-for="(doctor, index) in doctorDetails"
                        :key="index">
                        <span v-if="doctor.name !== '' && typeof doctor.name !== 'undefined'">
                          {{ doctor.name }}
                        </span>
                        <span v-else>
                          Not recorded
                        </span>
                        <br>
                        <span v-if="doctor.phone !== '' && typeof doctor.phone !== 'undefined'">
                          <span class="font-weight-bold">Doctor Phone:</span> {{ doctor.phone }}
                        </span>
                      </span>
                      <br>
                      <span v-if="medicalDetails.detail !== '' && typeof medicalDetails.detail !== 'undefined'">
                        <span class="font-weight-bold">Medical Details:</span> {{ medicalDetails.detail }}
                        <br>
                      </span>
                      <span v-if="medicalDetails.medication !== '' && typeof medicalDetails.medication !== 'undefined'">
                        <span class="font-weight-bold">Medication:</span> {{ medicalDetails.medication }}
                        <br>
                      </span>
                      <span v-if="medicalDetails.allergies !== '' && typeof medicalDetails.allergies !== 'undefined'">
                        <span class="font-weight-bold">Allergies:</span> {{ medicalDetails.allergies }}
                        <br>
                      </span>
                    </span>
                  </v-tab-item>
                  <v-tab-item
                    value="tab-4"
                    class="pl-2"
                    transition="fade-transition"
                    reverse-transition="fade-transition">
                    <v-row
                    >
                      <v-col
                        cols="12"
                        class="pb-1"
                        v-for="(permission, i) in permissions"
                        :key="i">
                        <b>{{ permission.title }}</b>:
                        <template v-if="permission.data !== null">
                          <template v-if="permission.data.includes('https://')">
                            <a
                              :href="permission.data"
                              target="_blank">{{ permission.data }}</a>
                          </template>
                          <template v-else>
                            {{ permission.data }}
                          </template>
                        </template>
                        <span v-else>Not recorded</span>
                        <br>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item
                    value="tab-5"
                    class="pl-2"
                    transition="fade-transition"
                    reverse-transition="fade-transition">
                    <v-row>
                      <v-col
                        cols="12"
                        class="pb-3"
                        v-for="(rollUserClassArr, rollUserClass) in otherDetailsArr"
                        :key="rollUserClass">
                        <span class="font-weight-bold font-italic subheading">{{ rollUserClass }}</span>
                        <br>
                        <span
                          v-for="(rollUserField, i) in rollUserClassArr"
                          :key="i">
                          <span class="font-weight-bold">{{ rollUserField.title }}</span>:
                          <template v-if="rollUserField.data.includes('https://')">
                            <a
                              :href="rollUserField.data"
                              target="_blank">{{ rollUserField.data }}</a>
                          </template>
                          <template v-else>
                            {{ rollUserField.data }}
                          </template>
                        </span>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item
                    value="tab-6"
                    class="pl-2"
                    transition="fade-transition"
                    reverse-transition="fade-transition">
                    <v-col
                      cols="12"
                      class="pb-3"
                      v-for="(attendanceArr, attendanceClass) in attendance"
                      :key="attendanceClass">
                      <v-alert
                        dense
                        type="info"
                      >
                        <strong>P</strong> : Present,
                        <strong>L</strong> : Student late for class,
                        <strong>M</strong> : Student absent due to short-term illness/medical reasons,
                        <strong>?</strong> : Unknown reason (temporary code)
                      </v-alert>
                      <span
                        v-for="(attendanceField, i) in attendanceArr"
                        :key="i">
                        <div v-if="attendanceField.hasOwnProperty('Morning') && attendanceField.Morning.schoolcode !== ''">
                          <span class="font-weight-bold">Morning: {{ attendanceField.Morning.schoolcode }}</span>
                        </div>
                        <br>
                        <div v-if="attendanceField.hasOwnProperty('Afternoon') && attendanceField.Afternoon.schoolcode !== ''">
                          <span class="font-weight-bold">Afternoon: {{ attendanceField.Afternoon.schoolcode }}</span>
                        </div>
                    </span></v-col>
                  </v-tab-item>
                </v-tabs-items>

              </v-col>
            </v-row>

          </v-container>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  data: () => ({
    pupilDetails: {},
    caregiverDetails: {},
    caregiverPanels: [],
    doctorDetails: {},
    medicalDetails: {},
    permissions: {},
    otherDetailsArr: {},
    attendance: {},
    active: 'tab-1',
    dialogVisible: false,
    showChildUpdateButton: false,
    editedCaregiver: {
      email: '',
      address: '',
      address2: '',
      mobile: '',
      phone: '',
      workphone: ''
    },
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    headers: [
      { text: 'Name', value: 'name', sortable: false },
      { text: 'Address', value: 'address', sortable: false },
      { text: 'Phone', value: 'phone', sortable: false },
      { text: 'Mobile', value: 'mobile', sortable: false },
      { text: 'Email', value: 'email', sortable: false },
      { text: 'Work Phone', value: 'workphone', sortable: false }
    ],

    detailHeadings: {
      'Admission Date': 'admissionDate',
      'Gender': 'gender',
      'DOB': 'DOB',
      'Ethnicity': 'ethnicity',
      'Language': 'language',
      'Citizenship': 'citizenship',
      'Zone Info': 'zoneInfo',
      'Teacher/s': 'teacher',
      'Age at January 1st': 'ageAtFirstOfJan',
      'Address': 'address'
    },

    detailHeadingsForTable: [
      {
        heading: 'Admission Date',
        detailName: 'admissionDate'
      },
      {
        heading: 'Gender',
        detailName: 'gender'
      },
      {
        heading: 'Date of Birth',
        detailName: 'DOB'
      },
      {
        heading: 'Ethnicity',
        detailName: 'ethnicity'
      },
      {
        heading: 'Ethnicity 2',
        detailName: 'ethnicity2'
      },
      {
        heading: 'Ethnicity 3',
        detailName: 'ethnicity3'
      },
      {
        heading: 'Language',
        detailName: 'language'
      },
      {
        heading: 'Citizenship',
        detailName: 'citizenship'
      },
      {
        heading: 'Teacher(s)',
        detailName: 'teacher'
      },
      {
        heading: 'Age at January this year',
        detailName: 'ageAtFirstOfJan'
      },
      {
        heading: 'Address',
        detailName: 'address'
      }
    ]
  }),

  computed: {
    ...mapGetters([
      'pupilPhoto',
      'pupilFullName',
      'pupilRoom',
      'pupilForm'
    ]),
    ...mapState(['Dbasename']),
    menuConfig: function () {
      return this.$store.state.menuConfig
    }
  },
  methods: {
    openUpdate () {
      this.dialogVisible = true
    },
    updateCaregiverDetails () {
      this.$http.post('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId + '/updateContactDetailsTestV2', {
        email: this.editedCaregiver.email,
        address: this.editedCaregiver.address,
        address2: this.editedCaregiver.address2,
        mobile: this.editedCaregiver.mobile,
        phone: this.editedCaregiver.phone,
        workphone: this.editedCaregiver.workphone
      })
        .then(resp => {
          if (resp.status === 200) {
            this.dialogVisible = false
            const pending = resp.data.pending === true

            this.showMessage(
              resp.data.message || 'Contact details updated successfully',
              pending ? 'Request Submitted' : 'Success',
              'success',
              pending // pending messages need a button so they can be read
            )

            // Nothing has changed yet when pending, so no reload needed
            if (!pending) {
              setTimeout(() => {
                location.reload()
              }, 1000)
            }
          }
        })
        .catch(error => {
          console.error('Failed to update details', error)
          const msg = (error.response && error.response.data && error.response.data.message) ||
        'Could not update details, please try again'
          this.showMessage(msg, 'Error', 'error', true)
        })
    },
    async showMessage (message, title = 'Success', icon = 'success', showConfirmButton = false) {
      await this.$swal({
        icon,
        title,
        text: message,
        showConfirmButton
      })
    }
    // updateCaregiverDetails () {
    //   console.log(this.$store.state.userId)
    //   this.$http.post('pupilsV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId + '/updateContactDetailsTestV2', {
    //     email: this.editedCaregiver.email,
    //     address: this.editedCaregiver.address,
    //     address2: this.editedCaregiver.address2,
    //     mobile: this.editedCaregiver.mobile,
    //     phone: this.editedCaregiver.phone,
    //     workphone: this.editedCaregiver.workphone
    //   })
    //     .then(resp => {
    //       if (resp.status === 200) {
    //         this.dialogVisible = false
    //         this.showMessage('Contact details updated successfully')
    //         setTimeout(() => {
    //           location.reload()
    //         }, 1000)
    //       }
    //     })
    //     .catch(error => {
    //       console.error('Failed to update details', error)
    //     })
    // },
    // async showMessage (message) {
    //   await this.$swal({
    //     icon: 'success',
    //     title: 'Success',
    //     text: message,
    //     showConfirmButton: false
    //   })
    // }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Get pupil details
      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/' + vm.$store.state.trueUser + '/detailsV2')
        .then(resp => {
          vm.pupilDetails = resp.data.pupilDetails
          vm.caregiverDetails = resp.data.caregiverDetails
          vm.caregiverPanels = [...vm.caregiverDetails.keys()].map(_ => true)
          vm.doctorDetails = resp.data.doctorDetails
          vm.medicalDetails = resp.data.medicalDetails
          vm.permissions = resp.data.permissions
          vm.otherDetailsArr = resp.data.otherDetailsArr
          vm.attendance = resp.data.attendance
          vm.$store.commit('loading', false)
        })

      vm.$http.get('childUpdateConfigV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.showChildUpdateButton = resp.data
        })
    })
  }
}
</script>

<style>
.details-table .theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: none;
}
</style>
